__turbopack_context__.v({
  "breadcrumbs": "BreadCrumb-module__Pe4rtq__breadcrumbs",
});
